export default __webpack_public_path__ + "locales/fr/EmptyTrashDialog.json?hash=8a386e4dd7577c87b9288ca62826b5ac";